<template>
    <div class="dc-content">
        <div class="dc-content-header">{{ lbl.detail.detail }}</div>
        <div class="dc-content-item" v-html="strDetail"></div>
        <div class="dc-content-header" v-if="!isNews" >{{ lbl.detail.condition }}</div>
        <div class="dc-content-item" v-if="!isNews" v-html="strCondition"></div>
    </div>
</template>
<script>
import Vue from "vue";
import Util from "@/helper/Utility.js";

/**
 * @event clickChangeTab
 */
export default {
    name: "CampaignDetailAndCondtition",
    props: {
        lbl: Object,
        campaign: Object,
        busEvent: Object
    },
    data: function() {
        return {
            strActiveTab: "detail", //detail, condition
            strDetail: "",
            strCondition: "",
            isNews: false
        };
    },
    created: function() {
        if (Vue.CampaignType.News == this.campaign.type) {
            this.isNews = true;
        }
        this.strDetail = this.initialDetail(this.campaign.detail);
        this.strCondition = this.initialDetail(this.campaign.condition);
    },
    methods: {
        clickChangeTab: function(strTab) {
            this.strActiveTab = strTab;
        },

        initialDetail: function (text) {
            var urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/ig;
            var result = text.replace(urlRegex, function (url) {
                return '<a class="dc-link" href="' + url + '" target="_blank">' + url + '</a>';
            });

            return Util.newLineToBr(result);
        }
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/base/common.scss";

.dc-content {
    .dc-content-header {
        color: $font-gray-header-color;
        margin-top: 20px;
        font-size: 20px;
        font-weight: 500;
    }

    .dc-content-item {
        color: $font-gray-color;
        line-height: 1.2;
        font-size: 18px;
        // font-family: Tahoma;
    }
}
</style>
